import React, { useRef, useCallback, useState } from 'react';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';

import api from '../../../../services/api';
import { useToast } from '../../../../hooks/toast';

import Input from '../../../Input';
import getResponseErrors from '../../../../utils/getResponseErrors';
import { IContratoAssinado } from '..';

type AssinadoProps = {
  ConCodigo: number;
  ConAssinado: boolean;
  handleAssinado(data: IContratoAssinado): void;
};

const Assinado: React.FC<AssinadoProps> = ({
  ConCodigo,
  ConAssinado,
  handleAssinado,
}) => {
  const formRef = useRef<FormHandles>(null);
  const { addToast } = useToast();
  const name = `name-${ConCodigo}`;

  const [loading, setLoading] = useState(false);
  const [assinado, setAssinado] = useState(ConAssinado);

  const handleOnClick = useCallback(async () => {
    setLoading(true);
    try {
      const retorno = await api.patch(`planos/contratoAssinado/${ConCodigo}`, {
        ConAssinado: !assinado,
      });

      setAssinado(!assinado);
      handleAssinado({
        ConCodigo,
        ConAssinado: !assinado,
        PlaContratoAssinado: retorno.data.contratoAssinado,
      });
    } catch (error) {
      const mensagem = getResponseErrors(error);
      addToast({
        type: 'error',
        title: 'Não foi possível atualizar informação',
        description: mensagem,
      });
    } finally {
      setLoading(false);
    }
  }, [ConCodigo, assinado, addToast, handleAssinado]);

  const handleSubmit = useCallback(() => {
    console.log('clicou');
  }, []);

  return (
    <Form ref={formRef} onSubmit={handleSubmit}>
      <Input
        label=""
        disabled={loading}
        name={name}
        onClick={handleOnClick}
        type="checkbox"
        onChange={handleSubmit}
        checked={assinado}
        containerStyle={{ borderWidth: 0 }}
      />
    </Form>
  );
};

export default Assinado;
